Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (ctx.isPDF) { ;
__p += '\n  <p style="\n    ' +
((__t = ( ctx.styles )) == null ? '' : __t) +
'\n    margin: 0;\n  ">\n    ' +
((__t = (ctx.tag)) == null ? '' : __t) +
'\n  </p>\n';
 } else { ;
__p += '\n  <div class="formio-component-esignature">\n    ' +
((__t = ( ctx.t(ctx.component.label, { _userInput: true }) || ctx.t(ctx.eSignType, { _userInput: true }) )) == null ? '' : __t) +
'\n  </div>\n';
 } ;

return __p
}